export default {
    index: {
        listagem_faixa_resultado: 'Listado de Rango de Resultados',
        faixa_resultado_nao_encontrada: 'No se ha encontrado ningún rango de resultados',
        criar_faixa_resultado: 'Crear Rango de Resultados',
        origem: 'Origen',
        destino: 'Destino',
        exame: 'Examen',
        editar: 'Editar'
    },
    form: {
        integracao_origem: 'Integración de Origen',
        integracao_destino: 'Integración de Destino',
        exame: 'Examen',
        condicoes: 'Condiciones',
        salvar: 'Ahorrar',
        status_descricao: 'Estado de conversión de resultados',
        titulo_editar: 'Editar Resultado de Conversión',
        titulo_criar: 'Crear Nueva Conversión de Resultados',
        integracao_origem_obrigatoria: '¡La selección de integración de fuente es obligatoria!',
        integracao_destino_obrigatoria: '¡La selección de integración de destino es obligatoria!',
        exame_obrigatorio: '¡La selección del examen es obligatoria!',
        criada_sucesso: 'Configuración de rango de resultados creada con éxito',
        editada_sucesso: 'Configuración de rango de resultados actualizada con éxito'
    }
}